import { appLogging } from "./appLogging";

export { makeContextProvider } from "@bindery/logging/client";

export const { logging } = appLogging;

export const { createLogger } = logging;
